module.exports = __webpack_public_path__ + "static_1727318417925/img/headder.529e00a1.jpg";